import { gql } from "lib/apolloClient";

export const getGlobalGradesQuery = gql`
  query getGlobalGrades {
    platform {
      globalGrades {
        id
        uid
        name
        curriculumTypes
      }
    }
  }
`;

export const getCurriculumProgramByProgramIdQuery = gql`
  query getCurriculumProgramByPlatformId($id: String!) {
    planner {
      curriculumProgramDataByPlatformId(id: $id) {
        error
        subscriptionPlan
        subscriptionStatus
        crmId
      }
    }
  }
`;
